<template>
    <div>
        <div v-if="$store.state.webEnv || $store.state.apiEnv" style="
                padding: 5px;
                opacity: 0.8;
                position: fixed;
                top: 0px;
                left: 0px;
                z-index: 9999;
                color: #fff;
                background: #5daf34;">
            前端环境：{{$store.state.webEnv}}
            <br>
            后端环境：{{$store.state.apiEnv}}
        </div>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
        </keep-alive>
        <!-- 这里不会被keepalive -->
        <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </div>
</template>

<script>
export default {
    mounted() {
        let req = new XMLHttpRequest();
        req.open('GET', document.location, false);
        req.send(null);
        let arr = req.getAllResponseHeaders().split(/[\n]/);
        arr.forEach((v, k) => {
            if (v.split(':')[0] == 'env') {
                this.$store.state.webEnv = v.split(':')[1];
            }
        })
    }
}
</script>

